export enum MessageType {
	order = 'order',
	request_payment = 'request_payment',
	request_order = 'request_order',
	request_waiter = 'request_waiter',
	card_payment_complete = 'card_payment_complete',
	dish_ready_to_serve = 'dish_ready_to_serve',
}
